import React from 'react'

import {
    Table,
    OverlayTrigger,
} from 'react-bootstrap'

// icons
import FeatherIcon from 'feather-icons-react';

// loading
import SaleOrdersLodingSkeleton from './table__loadingSkeleton'

// react router
import { Link } from 'react-router-dom'

import { renderTooltipEdit } from '../tooltips/SaleOrders__Tooltips'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

export default function SaleOrdersTable(props) {
    // props
    const { orderStatusList } = props

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <Table responsive className="mb-0">
            <thead>
                <tr>
                    {
                        props.column__saleOrderNumber && (
                            <th width={80}>
                                <p className="text-capitalize">
                                    Order ID
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__orderDate && (
                            <th>
                                <p className="text-capitalize">
                                    Order Date
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__customers && (
                            <th>
                                <p className="text-capitalize">
                                    Customer
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__subTotal && (
                            <th>
                                <p className="text-capitalize">
                                    Sub Total
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__promoDiscount && (
                            <th>
                                <p className="text-capitalize">
                                    Discount
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__shipping && (
                            <th className="text-end">
                                <p className="text-capitalize">
                                    Shipping
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__total && (
                            <th className="text-end">
                                <p className="text-capitalize">
                                    Total
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__fullFillmentStatus && (
                            <th className="text-end">
                                <p className="text-capitalize">
                                    Fullfillment Status
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__paymentStatus && (
                            <th width={130} className="text-end">
                                <p className="text-capitalize">
                                    Payment Status
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__paymentMethod && (
                            <th width={130} className="text-end">
                                <p className="text-capitalize">
                                    Payment Method
                                </p>
                            </th>
                        )
                    }

                    <th width="60"></th>
                </tr>
            </thead>

            <tbody>
                {
                    props.loading ? (
                        <React.Fragment>
                            {
                                (props.loadingCount && props.loadingCount.length) && props.loadingCount.map(item => (
                                    <React.Fragment key={item}>
                                        <SaleOrdersLodingSkeleton />
                                    </React.Fragment>
                                ))
                            }
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {
                                (props.saleOrders && props.saleOrders.length) ? props.saleOrders.map(item => {
                                    return (
                                        <tr key={item.order_id}>

                                            {
                                                props.column__saleOrderNumber && (
                                                    <td className="column__saleOrderNumber">
                                                        <Link to={`${storeUrl}/my-sales/sale-orders/edit/${item.order_id}`} className="st-text-primary">
                                                            #{item.order_id}
                                                        </Link>
                                                        {
                                                            item.notes ? (
                                                                <p className="notes st-fs-14 position-absolute" title={item.notes} style={{
                                                                    marginTop: 4,
                                                                    maxWidth: 400,
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden"
                                                                }}>
                                                                    <span className="st-fw-600">Note for staff: </span> {item.notes}
                                                                </p>
                                                            ) : null
                                                        }
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__orderDate && (
                                                    <td className="column__orderDate">
                                                        <p className="">
                                                            {item.order_date}
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__customers && (
                                                    <td className="column__customers">
                                                        <p className="">
                                                            {item.customer_name}
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__subTotal && (
                                                    <td className="column__subTotal">
                                                        <p className="">
                                                            {item.sub_total}
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__promoDiscount && (
                                                    <td className="column__promoDiscount">
                                                        <p className="">
                                                            {item.promo_discount}
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__shipping && (
                                                    <td className="column__shipping text-end">
                                                        <p className="">
                                                            {item.shipping}
                                                        </p>
                                                    </td>
                                                )
                                            }


                                            {
                                                props.column__total && (
                                                    <td className="column__total text-end">
                                                        <p className="">
                                                            {item.order_amount}
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__fullFillmentStatus && (
                                                    <td className="column__fullFillmentStatus text-end">
                                                        <p className="text-capitalize">
                                                            {/* {
                                                                (orderStatusList?.length && orderStatusList.find(item => item.status_code === item.fullfillment_status)?.status_name) ?? ""
                                                            } */}
                                                            {
                                                                item?.fullfillment_status?.replaceAll("_", " ")?.toLowerCase()
                                                            }
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__paymentStatus && (
                                                    <td className="column__paymentStatus text-end">
                                                        <p className="text-capitalize">
                                                            {
                                                                item?.payment_status && item?.payment_status?.replaceAll("_", " ")?.toLowerCase()
                                                            }
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__paymentMethod && (
                                                    <td className="column__paymentMethod text-end">
                                                        <p className="">
                                                            {item.payment_method}
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            <td className="column__actions">
                                                <div className="d-flex justify-content-end">
                                                    <OverlayTrigger
                                                        placement={"left"}
                                                        overlay={renderTooltipEdit}
                                                    >
                                                        <Link
                                                            to={{
                                                                pathname: storeUrl + '/my-sales/sale-orders/edit/' + item.order_id,
                                                                state: { orderDetails: item }
                                                            }}
                                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center me-1"
                                                        >
                                                            <FeatherIcon
                                                                icon="edit-2"
                                                                size="15"
                                                                className="icon" />
                                                        </Link>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>

                                        </tr>
                                    )
                                }) : (
                                    !props.loading ? (
                                        <tr>
                                            <td colSpan="11">
                                                <p className="no-data-found text-center st-fw-700 py-1">
                                                    no data found
                                                </p>
                                            </td>
                                        </tr>
                                    ) : null
                                )
                            }
                        </React.Fragment>
                    )
                }

            </tbody>
        </Table>
    )
}
